import { render, staticRenderFns } from "./Shot.vue?vue&type=template&id=d15c71e0"
import script from "./Shot.vue?vue&type=script&lang=js"
export * from "./Shot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports